import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Spinner } from '@/components/ui/spinner'

import { useCreateDocumentPageThemeUserDefault } from '@/services/queries/document_themes_user_defaults'

export const SetDefaultThemeButton = ({
  documentPageThemeId,
}: {
  documentPageThemeId: string
}) => {
  const { isPending, mutate: setDefault } =
    useCreateDocumentPageThemeUserDefault()
  return (
    <DropdownMenuItem
      className="cursor-pointer"
      onClick={() =>
        setDefault({
          themeType: 'operation',
          documentPageThemeId,
        })
      }
    >
      {isPending ? (
        <>
          <Spinner /> Saving
        </>
      ) : (
        <span>Set Global Default</span>
      )}
    </DropdownMenuItem>
  )
}
